export default {
    tbc: 'TBC',
    cash: $localize `Cash`,
    debit: $localize `Debit`,
    credit: $localize `Credit`,
}